import { Component, Input } from "@angular/core";
import { IQuotationWarning } from "libraries/service/resources/quotation-quotations/IQuotationsQuotation";
import { NotificationType, INotification } from "libraries/interfaces/INotification";
import { ILabels } from "libraries/interfaces/ILabels";
import { Yii } from "libraries/interfaces/Yii";
import { BtnStyleTypes, Size } from "libraries/ui_button/btn.component";
import { WarningsResourceService } from "app_quotation/shared/resources/warnings/warnings-resource.service";
import { TraceSeverity, ErrorTracingService } from "libraries/service/error-tracing/error-tracing.service";
import { ILoader } from "libraries/component/loader/ILoader";
import { LoaderType } from "libraries/component/loader/loader.component";
import { finalize } from "rxjs/operators";
import { faExclamationTriangle, IconDefinition } from "@fortawesome/free-solid-svg-icons";

@Component({
    selector: 'cost-warning',
    template: `
        <div *ngFor="let warning of warningsList; trackBy: trackByFn;">
            <notification *ngIf="warning.isActive"
                [type]="notificationType.Warning">
                <div class="notification-content">
                    <div class="notification-message">
                        <fa-icon [icon]="iconExclamationTriangle"></fa-icon>
                        <span>{{warning.message}}</span>
                    </div>

                    <btn [type]="btnType"
                        [size]="btnSize"
                        [label]="wording.understand"
                        (click)="disableWarning(warning.id)">
                    </btn>
                </div>
            </notification>
        </div>

        <notification *ngIf="notificationError.active"
            [type]="notificationError.type">
            {{ notificationError.message }}
        </notification>

        <loader *ngIf="loader.active"
            [message]="loader.message"
            [type]="loader.type">
        </loader>
    `,
    styleUrls: ["./cost-warning.component.scss"]
})
export class CostWarningComponent {
    @Input()
    public warningsList: IQuotationWarning[];

    public notificationType: typeof NotificationType = NotificationType;
    public btnType: BtnStyleTypes = BtnStyleTypes.actionDo;
    public btnSize: Size = Size.small;

    public iconExclamationTriangle: IconDefinition = faExclamationTriangle;

    public readonly wording: ILabels = {
        understand: Yii.t('wui-watabi-js', "J'ai compris"),
        warningPatchError: Yii.t('wui-watabi-js', "La mise à jour de l'avertissement à échouer"),
        warningDisableLoader: Yii.t('wui-watabi-js', "Désactivation de l'avertissement en cours"),
    };

    public notificationError: INotification = {
        active: false,
        type: NotificationType.Error,
        message: this.wording.warningPatchError,
    };

    public loader: ILoader = {
        message: this.wording.warningDisableLoader,
        active: false,
        type: LoaderType.large,
    };

    constructor (
        private readonly errorTracingService: ErrorTracingService,
        private readonly warningsResourceService: WarningsResourceService,
    ) {}

    public trackByFn(index: number, item: { id: number }): number {
        return item.id;
    }

    public disableWarning(warningId: number): void {
        this.loader.active = true;

        this.warningsResourceService.patch(warningId, false).pipe(
            finalize(() => this.loader.active = false),
        ).subscribe({
            next: ((): void => {
                // Pour le moment, il ne peut y avoir qu'un seul avertissement par grille de prix.
                // Dans l'éventualité ou la fonctionnalitée évoluerai, il faudrait modifier la logique ci-dessous.
                this.warningsList[0].isActive = false;
            }),
            error: ((error: Error): void => {
                this.notificationError.active = true;
                this.errorTracingService.captureMessage(error.message, TraceSeverity.Warning);
            }),
        });
    }
}
